import React, { useState, useEffect, useContext } from "react";
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import '../styles/ForgotPasswordMobUI.css';
import {Link, useNavigate} from "react-router-dom";
import { UserContext } from './UserContext';
import ChangePassword from './ChangePassword';


const ForgotPasswordMobUI = (props) => {
  var navigate = useNavigate();
const [ email,setEmail] = useState("")

useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

const sendOtp = async () =>{
	
	if(email.length === 0){
	return	alert("Please Enter Email!!");
	}
let apiUrl = process.env.REACT_APP_API_URL + "/users/emailsend";
let apiParam = {
  method: 'POST',
  headers: {
     email: email,
   },
 
};
fetch(apiUrl, apiParam)
  .then((res) => (res.status === 200 ? res.json() : res.text()))
  .then((repos) => {
    if (repos.statusText ==="success") {
    
     alert("If the entered email is registered, OTP has been sent to eMail!","success")
      setTimeout(() => {
        navigate("/ChangePassword?email="+email);
       
      }, 1500);

    } else {
      props.showAlert("If the entered email is registered, OTP has been sent to eMail! ","success")
    }
  })
  .catch((err) => alert(JSON.stringify(err)));
};



const backtoLogin = () =>{
  navigate("/login");
}

  return (
	<div id="forgot_page_Mob">
	<svg class="Path_5_Mob_F" viewBox="1106.719 150.94 260.616 160.165">
		<path id="Path_5_Mob_F" d="M 1106.718994140625 245.1532287597656 L 1109.500366210938 311.1045532226562 L 1367.334716796875 220.0757598876953 L 1367.334716796875 150.9395446777344 L 1106.718994140625 245.1532287597656 Z">
		</path>
	</svg>
	<svg class="Path_6_Mob_F" viewBox="1230.339 -8.122 137.074 83.79">
		<path id="Path_6_Mob_F" d="M 1230.338989257812 75.66712951660156 L 1230.338989257812 40.45851898193359 L 1354.740966796875 -8.12246036529541 L 1367.138427734375 -0.8549958467483521 L 1367.4130859375 26.84274482727051 L 1230.338989257812 75.66712951660156 Z">
		</path>
	</svg>
	<svg class="Path_7_Mob_" viewBox="1277.994 95.944 95.817 59.109">
		<path id="Path_7_Mob_" d="M 1277.994018554688 127.1390762329102 L 1289.892700195312 155.0538787841797 L 1373.810791015625 123.9319610595703 L 1365.97314453125 95.94441986083984 L 1277.994018554688 127.1390762329102 Z">
		</path>
	</svg>
	<svg class="Path_1_Mob_F" viewBox="1083.29 150.902 284.045 160.202">
		<path id="Path_1_Mob_F" d="M 1367.334838867188 251.9999847412109 L 1341.938598632812 311.1045532226562 L 1083.289916992188 220.0543212890625 L 1083.289916992188 150.9024963378906 L 1367.334838867188 251.9999847412109 Z">
		</path>
	</svg>
	<svg class="Path_2_Mob_F" viewBox="1217.914 -8.93 149.499 84.597">
		<path id="Path_2_Mob_F" d="M 1356.298217773438 75.66712188720703 L 1367.4130859375 42.74979019165039 L 1231.896240234375 -8.12246036529541 C 1231.896240234375 -8.12246036529541 1222.323486328125 -9.939326286315918 1219.22412109375 -8.12246036529541 C 1216.124755859375 -6.305594444274902 1219.498779296875 -0.8549967408180237 1219.498779296875 -0.8549967408180237 L 1219.22412109375 26.84273910522461 L 1356.298217773438 75.66712188720703 Z">
		</path>
	</svg>
	<svg class="Path_3_Mob_F" viewBox="0 102.6 214.177 131.242">
		<path id="Path_3_Mob_F" d="M 0 102.5998382568359 L 214.1771545410156 178.6947174072266 L 214.1771545410156 233.8421325683594 L 0 155.1822509765625 L 0 102.5998382568359 Z">
		</path>
	</svg>

	<img id="image_Mob_F" src="image.png" srcset="image.png 1x, image@2x.png 2x" />
		
	<div id="Forgot_Password_Mob_F">
		<span>Forgot Password</span>
	</div>
	<div id="Enter_the_email_address_associ_Mob_F">
		<span>Enter the email address associated with your account<br/>and we'll send you a link to reset your password.</span>
	</div>
	<input placeholder="Email" class="ema_Mob_F" value={email} onChange={(e)=>setEmail(e.target.value)} />
		{/* <rect id="ema" rx="0" ry="0" x="0" y="0" width="312.5" height="31.599">
		</rect>
	</input> */}
	<button id="Group_9_Mob_F" onClick={()=>sendOtp()}>
		<svg class="Rectangle_2_Mob_F">
			<rect id="Rectangle_2_Mob_F" rx="3" ry="3" x="0" y="0" width="253.519" height="37.724">
			</rect>
		</svg>
		<div id="Continue_Mob_F">
			<span>Continue</span>
		</div>
	</button>
	<div onClick={()=>navigate('/signup')} id="Dont_have_an_account_Sign_up_Mob_F">
		<span>Don't have an account? </span><span style={{color:"blue"}}>Sign up</span>
	</div>
	<div id="Group_13_Mob_F" onClick={()=>backtoLogin()}>
		<div id="Back_Mob_F">
			<span>Back</span>
		</div>
		<img id="back_M" src="back.png" srcset="back.png 1x, back@2x.png 2x" />
			
	</div>
	<img onClick={()=>backtoLogin()} id="previous_Mob_F" src="previous.png" srcset="previous.png 1x, previous@2x.png 2x" />
		
</div>
  )
}

export default ForgotPasswordMobUI